import React from "react";
// import AboutImage from "../assets/about-us.png"
import professionalAttire from "../assets/professional-attire.jpg";

const About = () => {
  return (
    <section className="about_area section_gap" id="about">
      <div className="container">
        <div className="row justify-content-start align-items-center">
          <div className="col-lg-5">
            <div className="about_img">
              <img src={professionalAttire} alt="Professional Picture" className="rounded"/>
            </div>
          </div>

          <div className="offset-lg-1 col-lg-5">
            <div className="main_title text-left">
              <h2>Let me introduce myself</h2>
              <p>
                Hi! I'm Ryan Cordial, a diligent and self-taught programmer
                under the guidance of mentors since 2018, currently residing in
                the Philippines.
              </p>
              <p>
                I have been completely engrossed in coding since 2018, with a
                focus on full-stack development, and I have a strong dedication
                to quality. Outside of the screen, I enjoy doing sports outside,
                especially basketball. I'm excited to add my commitment and love
                of coding to a vibrant team and am well-positioned to contribute
                significantly to the field of software development.
              </p>
              <a
                className="primary_btn"
                href="https://drive.google.com/uc?id=1S14HDdYQ3Pm3rcSmhHmvr2H8LMUwEt4J&export=download"
                rel="noreferrer"
                target="_blank"
              >
                <span>Download CV</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
